export const smallScreenSize = 550;
export const mediumScreenSize = 768;
export const largeScreenSize = 992;
export const largestScreenSize = 1201;
export const xxlScreenSize = 1400;
